import React, { Component } from 'react'
import { specializationSpeciality } from '@services/api'
import { List, Icon } from 'antd'
import { inject, observer } from 'mobx-react'
import Item from './Item'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    state = { data: [], txtFilter: '', specialities: [] }
    componentDidMount() {
        this.refresh()
    }

    refresh = () =>
        specializationSpeciality
            .getList()
            .then(res => this.setState({ data: res.data.list, specialities: res.data.specialities }))

    render() {
        const { data, txtFilter, specialities } = this.state
        return !data.length ? (
            <Icon type="loading" />
        ) : (
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                <input
                    placeholder="חפש על פי מומחיות"
                    value={txtFilter}
                    onChange={e => this.setState({ txtFilter: e.target.value })}
                />
                <List
                    rowKey={item => item}
                    dataSource={[...new Set(data.map(connection => connection.specialization_id))].filter(spz =>
                        data
                            .find(connection => connection.specialization_id == spz)
                            .specializationName.includes(txtFilter)
                    )}
                    pagination={{
                        hideOnSinglePage: true,
                        perPage: 10
                    }}
                    renderItem={item => (
                        <List.Item>
                            <Item
                                connections={data.filter(con => con.specialization_id == item)}
                                refresh={this.refresh}
                                specialities={specialities}
                            />
                        </List.Item>
                    )}
                />
            </div>
        )
    }
}
